/**
 * 促单提交相关接口
 */
import request from '@/utils/request';
import {
  getQwEnv,
  sortASCII,
  oauthLoginApi,
  getUserInfoApi,
  getQwSignatureApi,
  getVipInfoApi,
} from '@/api/vipGiftRecommend';

/**
 * 获取时间范围内的订单列表
 * @param {Object} params - { corpid, external_userid, role_id, major_id, type, start_time, end_time, user_id, vip_id, sign }
 */
export async function getOrderListApi(params) {
  const response = await request({
    url: getQwEnv() + '/qy-weixin/program/facilitate-order-list',
    method: 'post',
    data: sortASCII(params),
  });
  return response.data;
}

/**
 * 获取促单发起人和类型下拉选项（合并接口）
 * @param {Object} params - { external_userid, corpid, type, sign }
 * @returns {Object} content.facilitators - 发起人列表, content.types - 类型列表
 */
export async function getFacilitatorTypeOptionsApi(params) {
  const response = await request({
    url: getQwEnv() + '/qy-weixin/program/facilitator-type-options',
    method: 'post',
    data: sortASCII(params),
  });
  return response.data;
}

/**
 * 提交促单
 * @param {Object} params - { corpid, external_userid, role_id, majorId, type, order, facilitator_id, type_id, content, start_time, end_time, amount, contact_userid, user_id, vip_id, sign }
 */
export async function submitPromotionApi(params) {
  const response = await request({
    url: getQwEnv() + '/qy-weixin/program/facilitate',
    method: 'post',
    data: sortASCII(params),
  });
  return response.data;
}

// 导出复用的工具方法
export { oauthLoginApi, getUserInfoApi, getQwSignatureApi, getVipInfoApi, getQwEnv, sortASCII };
